import { diunaImperiumChapters } from './content';
export const diunaImperiumCommonMistakes = diunaImperiumChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('NAJCZĘSTSZE BŁĘDY'));
